import {Box, Button, CircularProgress, Dialog, DialogTitle, Fab, Paper, TextField, Typography} from '@material-ui/core';
import {Dispatch, useState} from 'react';
import API from '../../../APIs/API';
type AddModalProps = {
    open: boolean;
    handleClose: () => void;
    load: Dispatch<any>;
};
export default function AddAgentModal(props: AddModalProps) {
    const {open, handleClose, load} = props;
    const emptyAgent = {
        firstName: '',
        lastName: '',
        email: '',
    };
    const [agent, setAgent] = useState(emptyAgent);
    const handleChange = (e: any, property: 'firstName' | 'lastName' | 'email') => {
        setAgent({...agent, [property]: e.target.value});
    };
    const handleSubmit = async () => {
        await API.Call('agents', 'POST', agent);
        setAgent(emptyAgent);
        load((prev: any) => !prev);
        handleClose();
    };
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>AGENT INFORMATION</DialogTitle>
            <Box margin={0} padding={2} width="80%">
                <TextField
                    id="firstname"
                    label="First Name"
                    value={agent.firstName}
                    onChange={(e) => handleChange(e, 'firstName')}
                />
            </Box>
            <Box margin={0} padding={2} width="80%">
                <TextField
                    id="lastname"
                    label="Last Name"
                    value={agent.lastName}
                    onChange={(e) => handleChange(e, 'lastName')}
                />
            </Box>
            <Box margin={0} padding={2} width="80%">
                <TextField id="email" label="Email ID" value={agent.email} onChange={(e) => handleChange(e, 'email')} />
            </Box>
            <Button color="primary" variant="contained" onClick={handleSubmit}>
                Submit
            </Button>
        </Dialog>
    );
}
